"use client";

import Image from "next/image";
import Flex from "@/shared/components/common/Flex";
import data from "@/public/data/landing.json";
import Link from "next/link";
import { Button } from "@/shared/components/common/button";
import useScroll from "@/shared/hooks/useScroll";
import { ChatTeardropDots, Moon, User } from "@phosphor-icons/react";
import Separator from "@/shared/components/common/separator";

import logo from "@/public/images/logo-persian.webp";

export default function HeaderSkeleton() {
  const {
    header: { btns, nav },
  } = data;

  const { direction } = useScroll();

  return (
    <header
      className={`w-full h-16 flex md:px-8 border-b border-grayColor bg-background max-md:hidden sticky top-0 right-0 left-0 z-40 ${
        direction === "down" && "md:-translate-y-full"
      } transition duration-200 easeInOutCirc`}
    >
      <Flex className="xl:basis-4/5 basis-full items-center justify-between m-auto">
        <Flex className="basis-1/5 max-md:basis-2/4 max-lg:w-1/2 items-center justify-center gap-x-8">
          <Link href={"/"}>
            <Image
              src={logo}
              priority
              width={400}
              height={200}
              className="h-12 w-auto"
              alt="logo"
            />
          </Link>
        </Flex>

        <Flex className="basis-3/5 max-lg:hidden items-center">
          <nav className="relative z-10 flex max-w-max flex-1 items-center justify-center">
            <ul className="relative flex flex-1 list-none items-center justify-evenly flex-row-reverse space-x-1">
              {nav.links.map(({ title, link }) => (
                <li key={`nav-${link}`}>
                  <Link href={link}>
                    <Button
                      variant={"ghost"}
                      className="text-sm text-ghost hover:text-primary font-medium border-none shadow-none! rounded-xs"
                    >
                      {title}
                    </Button>
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </Flex>

        <Flex className="basis-1/5 max-md:basis-1/4 max-lg:w-1/2 justify-center items-center md:gap-x-2">
          {btns.map(({ text, name, link }) => {
            if (name === "loginSignup") return null;

            return (
              <Link href={link} key={name}>
                <Button
                  variant={"outline"}
                  className="border-none shadow-none! rounded-xs max-sm:hidden"
                >
                  <ChatTeardropDots
                    weight="duotone"
                    className="w-5 h-5 fill-primary md:mx-2"
                  />
                  {text}
                </Button>
              </Link>
            );
          })}

          <Button
            variant={"outline"}
            className="border-none shadow-none! rounded-xs"
          >
            <User weight="duotone" className="fill-primary mx-2" />
            {btns[1].text}
          </Button>

          <Separator direction="vertical" className="!h-5 bg-muted" />

          <div className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-background/10 ring-1 ring-ring">
            <Moon size={22} className="text-foreground" />
          </div>
        </Flex>
      </Flex>
    </header>
  );
}
